import type { BaseSlug } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'

export interface ProductProps {
  slugs: BaseSlug
  name: { vi: string; en: string }
  className?: string
}

const ProductCardName = ({ className, name, slugs }: ProductProps) => {
  return (
    <div className={className}>
      <Link
        href={'/' + getTranslate(slugs?.value) + slugs?.postfix}
        className='line-clamp-2 h-[32.6px] w-full text-ellipsis text-xs leading-[16.3px] text-main'
      >
        {getTranslate(name)}
      </Link>
    </div>
  )
}

export default ProductCardName
